import React, { useCallback, forwardRef } from 'react'
import { useDispatch } from 'react-redux'

import PropTypes from 'prop-types'

import isEmpty from 'lodash/isEmpty'
import toLower from 'lodash/toLower'

import brandSchema from '@galo-monitor/forms/schemas/root/brand.schema'
import { useT } from '@galo-monitor/i18n'
import { useSnackbar } from '@galo-monitor/snackbar'
import { BrandActions } from '@galo-monitor/stores/brand'
import Form from '@galo-monitor/web-components/Form'
import InputColor from '@galo-monitor/web-components/InputColor'
import InputText from '@galo-monitor/web-components/InputText'

import { Container } from './theme'

const BrandForm = forwardRef((props, formRef) => {
  const { brand, loading, setLoading, onSuccess, onError } = props
  const dispatch = useCallback(useDispatch(), [])
  const t = useT()
  const snackbar = useSnackbar()

  const handleSubmit = useCallback(
    data => {
      setLoading(true)
      dispatch(BrandActions.saveBrand(
        {
          ...brand,
          ...data
        },
        () => {
          snackbar.success(t('{this} {action} successfully!', {
            this: t('brand', { howMany: 1 }),
            action: toLower(t(isEmpty(brand) ? 'created' : 'updated', { gender: 'female', howMany: 1 }))
          }))
          onSuccess()
        },
        onError
      ))
    },
    [brand, dispatch, onError, onSuccess, setLoading, snackbar, t]
  )

  return (
    <Form
      ref={ formRef }
      schemaConstructor={ brandSchema }
      onSubmit={ handleSubmit }
    >
      <Container>
        <InputText
          name="name"
          label={ t('name') }
          defaultValue={ brand?.name || '' }
          disabled={ loading }
          fullWidth
        />

        <InputColor
          name="color"
          label={ t('color') }
          defaultValue={ brand?.color || '' }
          fullWidth
        />
      </Container>
    </Form>
  )
})

BrandForm.propTypes = {
  brand: PropTypes.object,
  loading: PropTypes.bool,
  setLoading: PropTypes.func,
  onSuccess: PropTypes.func,
  onError: PropTypes.func
}

BrandForm.defaultProps = {
  brand: {},
  loading: false,
  setLoading: () => {},
  onSuccess: () => {},
  onError: () => {}
}

export default BrandForm
